import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_neon-fix-dark/artifacts/j4zm2tv7_logo%20vaz%20tech.jpeg";
const WHATSAPP_NUMBER = "5521980277322";

const services = [
  { name: "Reparo de Celular", path: "/celular" },
  { name: "Reparo de Notebook", path: "/notebook" },
  { name: "Reparo de Smartwatch", path: "/smartwatch" },
  { name: "Reparo de Computador", path: "/computador" },
  { name: "Criação de Sites", path: "/webdesign" },
];

const quickLinks = [
  { name: "Início", path: "/" },
  { name: "Sobre Nós", path: "/#sobre" },
  { name: "Serviços", path: "/#servicos" },
  { name: "Depoimentos", path: "/#depoimentos" },
  { name: "FAQ", path: "/#faq" },
  { name: "Contato", path: "/#contato" },
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#050505] border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & About */}
          <div>
            <Link to="/" className="inline-block mb-6">
              <img src={LOGO_URL} alt="Vaz Tech Solutions" className="h-12" />
            </Link>
            <p className="text-[#94A3B8] text-sm font-space leading-relaxed mb-6">
              Assistência técnica especializada em smartphones, notebooks, smartwatches e computadores na Barra da Tijuca, Rio de Janeiro.
            </p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com/vaztech_barra"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                data-testid="footer-instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href={`https://wa.me/${WHATSAPP_NUMBER}`}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                data-testid="footer-whatsapp"
              >
                <Phone size={18} />
              </a>
              <a
                href="mailto:vaztechbarra@gmail.com"
                className="social-icon"
                data-testid="footer-email"
              >
                <Mail size={18} />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-rajdhani font-bold text-white text-lg mb-6">Serviços</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to={service.path}
                    className="footer-link text-sm font-space"
                    data-testid={`footer-service-${index}`}
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-rajdhani font-bold text-white text-lg mb-6">Links Rápidos</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="footer-link text-sm font-space"
                    data-testid={`footer-link-${index}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-rajdhani font-bold text-white text-lg mb-6">Contato</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`https://wa.me/${WHATSAPP_NUMBER}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 footer-link text-sm font-space"
                >
                  <Phone size={16} className="text-[#00F0FF] flex-shrink-0 mt-0.5" />
                  (21) 98027-7322
                </a>
              </li>
              <li>
                <a
                  href="mailto:vaztechbarra@gmail.com"
                  className="flex items-start gap-3 footer-link text-sm font-space"
                >
                  <Mail size={16} className="text-[#00F0FF] flex-shrink-0 mt-0.5" />
                  vaztechbarra@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="https://maps.google.com/?q=Av.+Embaixador+Abelardo+Bueno,+1340+-+Barra+da+Tijuca,+RJ"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 footer-link text-sm font-space"
                >
                  <MapPin size={16} className="text-[#00F0FF] flex-shrink-0 mt-0.5" />
                  Av. Embaixador Abelardo Bueno, 1340<br />
                  Barra da Tijuca, RJ
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="cyber-divider my-12"></div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-[#94A3B8] font-space">
          <p>
            © {currentYear} Vaz Tech Solutions. Todos os direitos reservados.
          </p>
          <p>
            Desenvolvido por{' '}
            <span className="text-white">Sucesso Vip Empreendimentos</span>
            {' '}para Vaz Tech Ltda
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
